export default __webpack_public_path__ + "static/Label-da13349e51ee514e8bed1e6a2082173f.png";